import React from 'react';

const SelectDropDown = React.forwardRef((props, ref) => {
    const { options, ...rest } = props;

    // Check if the option is an object with `value` and `label` keys
    const isOptionObject = (option) => {
        return option !== null && typeof option === 'object' && 'value' in option && 'label' in option;
    };

    return (
        <select ref={ref} {...rest}>
            {options.map((option, index) => {
                const value = isOptionObject(option) ? option.value : option;
                const label = isOptionObject(option) ? option.label : option;
                const disabled = isOptionObject(option) ? option.disabled : false;
                return (
                    <option key={index} value={value} disabled={disabled}>
                        {label}
                    </option>
                );
            })}
        </select>
    );
});


export default SelectDropDown;



// import React from "react";

// export function SelectDropDown({ register, options, name, ...rest }) {
//     return (
//         <select name={name}  {...register} {...rest}>
//             {options.map(value => (
//                 <option key={value} value={value}>
//                     {value}
//                 </option>
//             ))}
//         </select>
//     );
// }
